import type { Money, RentalLineItem } from '@jucy/rentals-api-client';
import { ProductType } from '@jucy/rentals-api-client';
import { ExcessType, RentalExcessReductionAllOfExcess } from '@jucy/rentals-api-client/rentals-api/models';
import { makeAutoObservable } from 'mobx';

export default class Product implements Omit<RentalLineItem, 'excess' | 'excessType' | 'price' | 'total' | 'bond' | 'qty'> {
    productId = '';
    productCode = '';
    name = '';
    category = '';
    isMandatory = false;
    description = '';
    price: Money = { currencyCode: '', value: 0 };
    total: Money = { currencyCode: '', value: 0 };
    bond?: Money = { currencyCode: '', value: 0 };
    productType: ProductType = ProductType.Fixed;
    allowMultiple = false;
    quantity = 1;
    rentalDays = 0;
    isExcluded = false;
    excessType: ExcessType | null = null;
    excess: RentalExcessReductionAllOfExcess | null = null;
    apiOrder = 0;

    constructor(props?: Partial<Product>) {
        makeAutoObservable(this);
        Object.assign(this, props);
    }

    get sortOrder() {
        return this.apiOrder;
    }
}
